import AllPayments from "../../components/admin/all-payments";



const AllPaymentsPage = () => {
  return (
    <AllPayments />
  );
};

export default AllPaymentsPage;